export default "__VITE_ASSET__Cx1fiy8z__"